import React from "react";
import { Navigate } from "react-router-dom";

import { userRoles } from "@/Core";
import { routesIndex } from "@/RoutesIndex";
import { useAppSelector } from "@/redux/hooks";

const AdesioniSessionRecovery = React.lazy(() => import("./AdesioniSessionRecovery"));

export const AdesioniSessionRecoveryGuard = () => {
    const role = useAppSelector((s) => s.authentication.data?.user?.role);
    if (role !== userRoles.administrator) {
        return <Navigate to={routesIndex.app.search} replace />;
    }
    return <AdesioniSessionRecovery />;
};
